import axios, { CancelToken } from 'axios';
import moment from 'moment';
import {
  AvailableBlockOperatory,
  SearchingService,
} from 'interfaces/timeslotType';

interface IParams {
  clinicId: string;
  dates: string[];
  serviceId: string;
  timezone: string;
  timeBlocks: number[] | string[];
  gender?: string[];
  code?: string;
  serviceSlugName?: string;
  cancelToken?: CancelToken;
  dentistId?: string;
  insuranceId?: string;
  familyBookingSessionId?: string;
}

export interface IWeeklyTimeSlotsClinicData {
  id: string;
  doctors: {
    id: string;
    firstName: string;
    lastName: string;
    name: string;
    title: string;
    specialist: string;
    avatar?: string | null;
    doctorInsurances: { insuranceCarrierId: string; isInNetwork: boolean }[];
    availableBlocks: {
      date: string;
      availableBlockOperatories?: AvailableBlockOperatory[];
      blocks: number[];
      searchingService: SearchingService;
      isOptimizedApplied: boolean;
      dentists: {
        dentistId: string;
        headAvailableBlockNumbers: number[];
        tailAvailableBlockNumbers: number[];
        doctorInsurances?: {
          insuranceCarrierId: string;
          isInNetwork: boolean;
        }[];
      }[];
    }[];
  }[];
  slotInterval: number;
}

export const getClinicAvailability = async ({
  clinicId,
  dates,
  serviceId,
  timezone,
  timeBlocks,
  gender,
  code,
  serviceSlugName,
  cancelToken,
  dentistId,
  insuranceId,
  familyBookingSessionId,
}: IParams) => {
  const res = await axios.get<IWeeklyTimeSlotsClinicData[]>(
    `clinics/${clinicId}/weekly-timeslots`,
    {
      baseURL: process.env.REACT_APP_AXIOS_BE_URL,
      params: {
        id: clinicId,
        dates: dates,
        serviceId: serviceId,
        currentDate: moment().format(),
        timeBlocks,
        timezone,
        ...(gender && { genders: gender }),
        ...(code && { code }),
        ...(serviceSlugName && { serviceSlugName }),
        ...(dentistId && { dentistId }),
        ...(insuranceId && { insuranceId }),
        ...(familyBookingSessionId && { familyBookingSessionId }),
      },
      cancelToken,
    }
  );

  return res.data[0];
};
